export default __webpack_public_path__ + "static/media/built-on-sure-logo.bf07170f.svg";